<template>
  <div class="bottom-nav" :class="{'bottom-nav--is-absolute': absolute}">
    <router-link class="bottom-nav__link bottom-nav__link--prev" :to="prev.to">
      {{ prev.label }}
    </router-link>
    <router-link class="bottom-nav__link bottom-nav__link--next" :to="next.to">
      {{ next.label }}
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    prev: Object,
    next: Object,
    absolute: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.bottom-nav {
  width: 100%;
  height: 40px;
  color: #fff;
  background: $c-purple;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 44px;
  box-sizing: border-box;

  &--is-absolute {
    position: absolute;
    bottom: 60px;
    left: 0;
    right: 0;
    width: auto;
  }

  &__link {
    color: #fff;
    text-decoration: none;
    position: relative;
    display: block;

    &--prev:before, &--next:before {
      display: block;
      content: "";
      position: absolute;
      left: -30px;
      border: 0;
      width: 25px;
      height: 17px;
      background-image: url('../assets/arrow-prev.svg');
      background-repeat: no-repeat;
      background-position: center;
    }

    &--next:before {
      left: auto;
      right: -30px;
      background-image: url('../assets/arrow-next.svg');
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BottomNav.vue